const state = {
  visibleSharingWindow: false,
  elementNameSharingWindow:'',
  elementIdSharingWindow:[],
  typeSharingWindow:''
}

const getters = {
  isVisibleSharingWindow: state => state.visibleSharingWindow,
  getElementNameSharingWindow: state => state.elementNameSharingWindow,
  getElementIdSharingWindow: state => state.elementIdSharingWindow,
  getTypeSharingWindow: state => state.typeSharingWindow,
}

const actions = {
  setConfigSharingWindow ({ commit }, payload) {
    commit('SET_SHARE_WINDOW', payload)
  },
}

const mutations = {
  SET_SHARE_WINDOW(state, payload){
    state.visibleSharingWindow = payload.visibility
    state.elementNameSharingWindow = payload.elementName||''
    state.elementIdSharingWindow = payload.id||[]
    state.typeSharingWindow = payload.type||''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}